import isEqual from "lodash/isEqual";
import sortBy from "lodash/sortBy";

const sameArrayValues = (array1: string[], array2: string[]) => {
    return isEqual(sortBy(array1), sortBy(array2));
};

export default sameArrayValues;
